import React from 'react'
import {Box} from 'grommet'
import LabUserForm from '../../components/labUserForm'
import { API,Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import {NavigationSnackBar} from '../../components/utils/shared/shared'
class LabCreateUser extends React.Component {

    state = {
        load: false,
        value: {name: '', password: '', email: ''},
        customer: {name: 'Select Customer...', primary_contact_person: '',primary_contact_email: '', primary_contact_phone: '',address:{AddressLineOne: '', AddressLineTwo: '',AddressLineThree: '',City: '',PostCode: '',Country: ''}}
    }

    handleCustomerChange = (event) => {
      this.setState({customer: event});
    };
      handleChange = (event) => {
          this.setState({value: event});
        };
  
    handleSubmit = () => {
      this.setState({load: true})
      const login = {username: this.state.value.username, password: this.state.value.password, email: this.state.value.email, customer: this.state.customer}
      Auth.currentSession().then(session => {
        API
        .post("LabShip", "/auth/lab_user_sign_up",
        { headers: { 
          Authorization: session.idToken.jwtToken,
        }, 
        body:login})
      .then(user => {
           this.setState({error: false, load:false})
           this.props.history.push({
             pathname: '/users/all',
           })
       }).catch(err => {
         this.setState({error:true, user: err, load:false})
         console.log(err)
      })
      })
      }
    
    render(){
        const {load,value, customer} = this.state;
        return ( 
          <Box>
            <NavigationSnackBar user={this.props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Users', link: '/users/all'}, {name: `Create User`}]}  />
            <Box direction='row' justify="center" flex="grow">
                <LabUserForm label={"Create User"} handleSubmit={this.handleSubmit} handleChange={this.handleChange} handleCustomerChange={this.handleCustomerChange} value={value} load={load} customer={customer}/>
            </Box>
          </Box>
          )
    }
}

export default withRouter(LabCreateUser)
